import React, { useState, useContext } from 'react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import ThumbtackListing from '/src/Components/ThumbtackListing/ThumbtackListing';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';
import ServiceVendorListings from '/src/Components/ServiceVendorListings/ServiceVendorListings';
import ProjectCostsHiringPro from '/src/Components/ProjectCostsHiringPro/ProjectCostsHiringPro';
import { MoveLeft } from 'lucide-react';
import { WindowSizeContext } from '/src/App';
import './style.css';

const GettingItDoneProfessional = ({ thumbtackListings, project }) => {

    const { deviceType } = useContext(WindowSizeContext);

    const getting_it_done_intro = "Utilizing a professional is a great way to ensure this project is done properly. If you decide to go this route...";

    const service_networks = [
        { id: 'thumbtack', name: "Thumbtack", url: "https://www.thumbtack.com/", icon: "thumbtack.png" },
        { id: 'angi', name: "Angi", url: "https://www.angi.com/", icon: "angi.png" },
        { id: 'homeadvisor', name: "HomeAdvisor", url: "https://www.homeadvisor.com/", icon: "homeadvisor.png" },
        { id: 'houzz', name: "Houzz", url: "https://www.houzz.com/", icon: "houzz.png" },
    ];

    const thumbtack_info_frame_icon = "thumbtack.png";

    // Create the state for whether to show the service / request flow iframe
    const [showIFrame, setShowIFrame] = useState(false);
    const [iframeUrl, setIframeUrl] = useState('');
    const [service_page_iframe_id, setServicePageIframeId] = useState('');
    // Handle the button click to show the service / request flow iframe
    const handleIFrameClick = (url, id) => {
        setIframeUrl(url);
        setServicePageIframeId(id);
        setShowIFrame(true);
    }

    const handleIFrameClose = () => {
        setShowIFrame(false);
        setIframeUrl('');
        setServicePageIframeId('');
    }

    console.log('showIFrame', showIFrame);
    console.log('iframeUrl', iframeUrl);

    const who_does_the_work = project.project_who_does_work;
    const who_does_the_work_icon = project.project_who_does_work_icon;

    const if_you_add_text = "If you add this project to Taking Action we can help you identify the best professionals and may even be able to get you a discount!"

    const project_cost_labor = project.project_cost_labor;
    const project_cost_labor_formatted = project_cost_labor.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const project_cost_materials = project.project_cost_materials;
    const project_cost_materials_formatted = project_cost_materials.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });

    const project_cost_total = project_cost_labor + project_cost_materials;
    const project_cost_total_formatted = project_cost_total.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });

    const showProjectCostLabor = project_cost_labor && project_cost_labor > 0;


    // Sort the thumbtack listings by rating
    const sortedThumbtackListings = thumbtackListings.sort((a, b) => b.rating - a.rating);

    // Get the top 3 listings
    const top3ThumbtackListings = sortedThumbtackListings.slice(0, 3);



    return (
        <div className={`getting-it-done-diy-container ${deviceType}`}>
            {!showIFrame && (
                <p className="getting-it-done-intro text-align-center">{getting_it_done_intro}</p>
            )}

            <div className={`professional-info-container ${deviceType}`}>
                <div className={`professional-type-column ${deviceType}`}>
                    <h3 className="professional-section-header">You're Looking For...</h3>
                    <div className="professional-type-info-container">
                        <div className="professional-type-info-name-container">

                            <div className={`professional-icon-container ${deviceType}`}>
                                <img
                                    src={CreateCloudfrontUrl(who_does_the_work_icon)}
                                    alt={who_does_the_work}
                                    className="professional-icon"
                                />
                            </div>
                            <p className="professional-type-text">{who_does_the_work}</p>
                        </div>
                        {showProjectCostLabor && (
                            <ProjectCostsHiringPro project={project} />
                            // <div className="professional-type-cost-container">
                            //     <div className="professional-type-cost-container-header">
                            //         <span>Est. Cost: {project_cost_total_formatted}</span>
                            //     </div>
                            //     <div className="professional-type-cost-container-breakdown">
                            //         <span className="professional-type-cost-text">Labor: {project_cost_labor_formatted}</span>
                            //         <span className="professional-type-cost-text">Materials: {project_cost_materials_formatted}</span>
                            //     </div>
                            // </div>
                        )}
                    </div>
                </div>

                <div className="service-networks-column">
                    {!showIFrame && (
                        <>
                            <h3 className="professional-section-header">Where to Find Them</h3>
                            <ServiceVendorListings
                                thumbtackListings={sortedThumbtackListings}
                                handleIFrameClick={handleIFrameClick}
                            />
                        </>
                    )}
                    {showIFrame && (
                        <div className="thumbtack-listing-iframe-container">
                            <button onClick={handleIFrameClose} className="thumbtack-listing-iframe-close-btn">
                                <MoveLeft />
                                Back
                            </button>
                            <iframe
                                src={iframeUrl}
                                className="thumbtack-listing-iframe"
                                id={service_page_iframe_id}
                                sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                                width="100%"
                                height="100%"
                            // style={{ border: 'none' }}
                            />
                        </div>
                    )}
                </div>
            </div>

            <p className="if-you-add-text text-align-center" dangerouslySetInnerHTML={{ __html: if_you_add_text }} />
        </div>
    );
};

export default GettingItDoneProfessional;
